import Lottie from 'react-lottie-player';

import { Stack } from '@mui/material';

import chainsEmptyStateAnimation from '@/components/Animations/EmptyStates/chains.json';
import modelApiEmptyStateAnimation from '@/components/Animations/EmptyStates/model-api.json';
import modelsEmptyStateAnimation from '@/components/Animations/EmptyStates/models.json';
import trainingEmptyStateAnimation from '@/components/Animations/EmptyStates/training.json';
import BaseAppLink from '@/components/AppLink';
import { styled } from '@/theme/styled';
import { getBorder } from '@/theme/utils';

const AppLink = styled(BaseAppLink)(({ theme }) => ({
  color: theme.palette.text.default,

  '&:hover': {
    textDecoration: 'none',
  },
}));

const Section = styled(Stack)(({ theme }) => ({
  borderBottom: getBorder(theme.palette.border.default),
  padding: theme.spacing(4),
  gap: theme.spacing(4),
}));

const DedicatedEmptyState = styled(Stack)(({ theme }) => ({
  padding: theme.spacing(6, 4),
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: theme.spacing(4),
}));

const EmptyState = styled(Stack)(({ theme }) => ({
  padding: theme.spacing(5),
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  flex: 1,
  backgroundColor: theme.palette.background.subtle,
  borderRadius: theme.shape.borderRadius,
}));

const ListItem = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(1),
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: theme.palette.background.subtle,

    '[data-cy="status-colors"]': {
      backgroundColor: theme.palette.background.muted,
    },
  },
}));

const Content = styled(Stack)(({ theme }) => ({
  flex: 1,
  overflow: 'auto',
  '&::-webkit-scrollbar': {
    display: 'none',
  },
  msOverflowStyle: 'none',
  scrollbarWidth: 'none',
}));

const ModelAPIAnimationContainer = styled(Lottie)({
  width: 120,
});

ModelAPIAnimationContainer.defaultProps = {
  loop: true,
  play: true,
  animationData: modelApiEmptyStateAnimation,
};

const ChainsAnimationContainer = styled(Lottie)({
  width: 120,
});

ChainsAnimationContainer.defaultProps = {
  loop: true,
  play: true,
  animationData: chainsEmptyStateAnimation,
};

const TrainingAnimationContainer = styled(Lottie)({
  width: 120,
});

TrainingAnimationContainer.defaultProps = {
  loop: true,
  play: true,
  animationData: trainingEmptyStateAnimation,
};

const ModelsAnimationContainer = styled(Lottie)({
  width: 120,
});

ModelsAnimationContainer.defaultProps = {
  loop: true,
  play: true,
  animationData: modelsEmptyStateAnimation,
};

export {
  Content,
  DedicatedEmptyState,
  EmptyState,
  Section,
  ListItem,
  AppLink,
  ModelAPIAnimationContainer,
  ChainsAnimationContainer,
  TrainingAnimationContainer,
  ModelsAnimationContainer,
};
